// import { createSlice } from '@reduxjs/toolkit'
// import {
//   getPatients,
//   deletePatient,
//   editPatient,
//   getPatient,
//   getAssignees,
//   getAssignedPatients,
//   assignPatient
// } from './patient.action'

// const initialState = {
//   // ========================
//   // All Patients Section
//   // ========================
//   isPatientsLoading: false,
//   isPatientsLoaded: false,
//   isPatientsLoadingFailed: false,
//   createPatientError: null,
//   patientsCurrentPage: 1,      // ✅ Changed from 0 to 1 (backend uses 1-based pagination)
//   patientsTotalPages: 0,
//   patients: [],
//   totalPatients: 0,
//   isDeletingPatient: false,
//   deletePatientError: null,
//   isEditingPatient: false,
//   isPatientEdited: false,

//   // ========================
//   // Single Patient Section
//   // ========================
//   isPatientLoading: false,
//   isPatientLoaded: false,
//   isPatientLoadingFailed: false,
//   patient: {},

//   // ========================
//   // Assignees Section
//   // ========================
//   isAssigneesLoading: false,
//   isAssigneesLoaded: false,
//   isAssigneesLoadingFailed: false,
//   assignees: [],

//   // ========================
//   // Assignment Feature
//   // ========================
//   isAssigningPatient: false,
//   assignPatientError: null,

//   // ========================
//   // Assigned Patients Section
//   // ========================
//   isAssignedPatientsLoading: false,
//   isAssignedPatientsLoaded: false,
//   isAssignedPatientsLoadingFailed: false,
//   createAssignedPatientError: null,
//   assignedPatientsCurrentPage: 1,
//   assignedPatientsTotalPages: 0,
//   assignedPatients: []
// }

// const patients = createSlice({
//   name: 'patients',
//   initialState,

//   extraReducers: builder => {
//     builder
//       // ============================================================
//       // GET PATIENTS HANDLERS - ✅ FIXED: Proper pagination handling
//       // ============================================================
//       .addCase(getPatients.pending, state => {
 
//         state.isPatientsLoading = true
//         state.isPatientsLoaded = false
//         state.isPatientsLoadingFailed = false
//         // ✅ Don't reset patients array on pending - keep previous data visible
//       })
//       .addCase(getPatients.fulfilled, (state, action) => {
//         console.log('✅ GET PATIENTS FULFILLED:', {
//           documentsCount: action.payload.documents?.length,
//           total: action.payload.total,
//           page: action.payload.currentPage,
//           totalPages: action.payload.totalPages
//         });
        
//         state.isPatientsLoading = false
//         state.isPatientsLoaded = true
//         state.isPatientsLoadingFailed = false
        
//         // ✅ Update state with proper response structure
//         state.patients = action.payload.documents || []
//         state.patientsCurrentPage = action.payload.currentPage || 1
//         state.patientsTotalPages = action.payload.totalPages || 0
//         state.totalPatients = action.payload.total || 0
        
//         console.log('✅ State updated:', {
//           patientsCount: state.patients.length,
//           currentPage: state.patientsCurrentPage,
//           totalPages: state.patientsTotalPages,
//           total: state.totalPatients
//         });
//       })
//       .addCase(getPatients.rejected, (state, action) => {
//         console.error('❌ GET PATIENTS REJECTED:', action.payload);
//         state.isPatientsLoading = false
//         state.isPatientsLoaded = false
//         state.isPatientsLoadingFailed = true
//         // ✅ Keep previous data on error for better UX
//         state.patients = state.patients || []
//       })

//       // ============================================================
//       // ASSIGN PATIENT HANDLERS
//       // ============================================================
//       .addCase(assignPatient.pending, (state) => {
//         console.log('⏳ ASSIGN PENDING: Setting isAssigningPatient = true');
//         state.isAssigningPatient = true;
//         state.assignPatientError = null;
//       })
//       .addCase(assignPatient.fulfilled, (state, action) => {
//         console.log('✅ ASSIGN FULFILLED: Updating state with patient:', action.payload);
//         state.isAssigningPatient = false;
        
//         const updated = action.payload;
//         if (!updated || !updated._id) {
//           console.warn('⚠️ No patient data in fulfilled action');
//           return;
//         }

//         // ✅ Update in `patients` array (if patient is in main list)
//         if (Array.isArray(state.patients)) {
//           const patientIndex = state.patients.findIndex((p) => p._id === updated._id);
//           if (patientIndex >= 0) {
//             console.log('📝 Updating patient in main list at index:', patientIndex);
//             state.patients[patientIndex] = { ...state.patients[patientIndex], ...updated };
//           }
//         }

//         // ✅ Upsert in `assignedPatients` array
//         if (!Array.isArray(state.assignedPatients)) {
//           state.assignedPatients = [];
//         }
        
//         const assignedIndex = state.assignedPatients.findIndex((p) => p._id === updated._id);
//         if (assignedIndex >= 0) {
//           console.log('📝 Updating assigned patient at index:', assignedIndex);
//           state.assignedPatients[assignedIndex] = { 
//             ...state.assignedPatients[assignedIndex], 
//             ...updated 
//           };
//         } else {
//           console.log('➕ Adding new assigned patient to list');
//           state.assignedPatients.unshift(updated);
//         }
//       })
//       .addCase(assignPatient.rejected, (state, action) => {
//         console.error('❌ ASSIGN REJECTED:', action.payload);
//         state.isAssigningPatient = false;
//         state.assignPatientError = action.payload || action.error?.message || 'Failed to assign';
//       })

//       // ============================================================
//       // DELETE PATIENT HANDLERS
//       // ============================================================
//       .addCase(deletePatient.pending, state => {
//         console.log('⏳ DELETE PATIENT PENDING');
//         state.isDeletingPatient = true
//         state.deletePatientError = null
//       })
//       .addCase(deletePatient.fulfilled, (state, action) => {
//         console.log('✅ DELETE PATIENT FULFILLED:', action.payload);
//         state.isDeletingPatient = false
//         state.patients = state.patients.filter(patient => patient._id !== action.payload)
//       })
//       .addCase(deletePatient.rejected, (state, action) => {
//         console.error('❌ DELETE PATIENT REJECTED:', action.error.message);
//         state.isDeletingPatient = false
//         state.deletePatientError = action.error.message
//       })

//       // ============================================================
//       // EDIT PATIENT HANDLERS
//       // ============================================================
//       .addCase(editPatient.fulfilled, (state, action) => {
//         console.log('✅ EDIT PATIENT FULFILLED:', action.payload);
//         state.isEditingPatient = false
//         state.isPatientEdited = true
//         state.patients = state.patients.map(patient => 
//           patient._id === action.payload._id ? action.payload : patient
//         )
//       })

//       // ============================================================
//       // GET SINGLE PATIENT HANDLERS
//       // ============================================================
//       .addCase(getPatient.pending, state => {
//         console.log('⏳ GET SINGLE PATIENT PENDING');
//         state.isPatientLoading = true
//         state.isPatientLoaded = false
//         state.isPatientLoadingFailed = false
//       })
//       .addCase(getPatient.fulfilled, (state, action) => {
//         console.log('✅ GET SINGLE PATIENT FULFILLED:', action.payload);
//         state.isPatientLoading = false
//         state.isPatientLoaded = true
//         state.patient = action.payload
//       })
//       .addCase(getPatient.rejected, state => {
//         console.error('❌ GET SINGLE PATIENT REJECTED');
//         state.isPatientLoading = false
//         state.isPatientLoadingFailed = true
//       })

//       // ============================================================
//       // GET ASSIGNEES HANDLERS
//       // ============================================================
//       .addCase(getAssignees.pending, state => {
//         console.log('⏳ GET ASSIGNEES PENDING');
//         state.isAssigneesLoading = true
//         state.isAssigneesLoaded = false
//         state.isAssigneesLoadingFailed = false
//       })
//       .addCase(getAssignees.fulfilled, (state, action) => {
//         console.log('✅ GET ASSIGNEES FULFILLED:', action.payload);
//         state.isAssigneesLoading = false
//         state.isAssigneesLoaded = true
//         state.assignees = action.payload
//       })
//       .addCase(getAssignees.rejected, state => {
//         console.error('❌ GET ASSIGNEES REJECTED');
//         state.isAssigneesLoading = false
//         state.isAssigneesLoadingFailed = true
//       })

//       // ============================================================
//       // GET ASSIGNED PATIENTS HANDLERS
//       // ============================================================
//       .addCase(getAssignedPatients.pending, state => {
//         console.log('⏳ GET ASSIGNED PATIENTS PENDING');
//         state.isAssignedPatientsLoading = true
//         state.isAssignedPatientsLoaded = false
//         state.isAssignedPatientsLoadingFailed = false
//       })
//       .addCase(getAssignedPatients.fulfilled, (state, action) => {
//         console.log('✅ GET ASSIGNED PATIENTS FULFILLED:', action.payload);
//         state.isAssignedPatientsLoading = false
//         state.isAssignedPatientsLoaded = true
//         state.assignedPatients = Array.isArray(action.payload) ? action.payload : []
//       })
//       .addCase(getAssignedPatients.rejected, (state, action) => {
//         console.error('❌ GET ASSIGNED PATIENTS REJECTED:', action.payload);
//         state.isAssignedPatientsLoading = false
//         state.isAssignedPatientsLoadingFailed = true
//         state.assignedPatients = state.assignedPatients || []
//       })
//   }
// })

// export default patients.reducer

import { createSlice } from '@reduxjs/toolkit'
import {
  getPatients,
  deletePatient,
  editPatient,
  getPatient,
  getAssignees,
  getAssignedPatients,
  assignPatient
} from './patient.action'

const initialState = {
  // ========================
  // All Patients Section
  // ========================
  isPatientsLoading: false,
  isPatientsLoaded: false,
  isPatientsLoadingFailed: false,
  createPatientError: null,
  patientsCurrentPage: 1,
  patientsTotalPages: 0,
  patients: [],
  totalPatients: 0,
  isDeletingPatient: false,
  deletePatientError: null,
  isEditingPatient: false,
  isPatientEdited: false,

  // ========================
  // Single Patient Section
  // ========================
  isPatientLoading: false,
  isPatientLoaded: false,
  isPatientLoadingFailed: false,
  patient: {},

  // ========================
  // Assignees Section
  // ========================
  isAssigneesLoading: false,
  isAssigneesLoaded: false,
  isAssigneesLoadingFailed: false,
  assignees: [],

  // ========================
  // Assignment Feature
  // ========================
  isAssigningPatient: false,
  assignPatientError: null,

  // ========================
  // Assigned Patients Section
  // ========================
  isAssignedPatientsLoading: false,
  isAssignedPatientsLoaded: false,
  isAssignedPatientsLoadingFailed: false,
  createAssignedPatientError: null,
  assignedPatientsCurrentPage: 1,
  assignedPatientsTotalPages: 0,
  assignedPatients: []
}

const patients = createSlice({
  name: 'patients',
  initialState,

  extraReducers: builder => {
    builder
      // ============================================================
      // GET PATIENTS HANDLERS
      // ============================================================
      .addCase(getPatients.pending, state => {
        state.isPatientsLoading = true
        state.isPatientsLoaded = false
        state.isPatientsLoadingFailed = false
      })
      .addCase(getPatients.fulfilled, (state, action) => {
        state.isPatientsLoading = false
        state.isPatientsLoaded = true
        state.isPatientsLoadingFailed = false
        state.patients = action.payload.documents || []
        state.patientsCurrentPage = action.payload.currentPage || 1
        state.patientsTotalPages = action.payload.totalPages || 0
        state.totalPatients = action.payload.total || 0
      })
      .addCase(getPatients.rejected, (state, action) => {
        state.isPatientsLoading = false
        state.isPatientsLoaded = false
        state.isPatientsLoadingFailed = true
        state.patients = state.patients || []
      })

      // ============================================================
      // ASSIGN PATIENT HANDLERS
      // ============================================================
      .addCase(assignPatient.pending, (state) => {
        state.isAssigningPatient = true;
        state.assignPatientError = null;
      })
      .addCase(assignPatient.fulfilled, (state, action) => {
        state.isAssigningPatient = false;

        const updated = action.payload;
        if (!updated || !updated._id) return;

        if (Array.isArray(state.patients)) {
          const patientIndex = state.patients.findIndex((p) => p._id === updated._id);
          if (patientIndex >= 0) {
            state.patients[patientIndex] = { ...state.patients[patientIndex], ...updated };
          }
        }

        if (!Array.isArray(state.assignedPatients)) {
          state.assignedPatients = [];
        }

        const assignedIndex = state.assignedPatients.findIndex((p) => p._id === updated._id);
        if (assignedIndex >= 0) {
          state.assignedPatients[assignedIndex] = {
            ...state.assignedPatients[assignedIndex],
            ...updated
          };
        } else {
          state.assignedPatients.unshift(updated);
        }
      })
      .addCase(assignPatient.rejected, (state, action) => {
        state.isAssigningPatient = false;
        state.assignPatientError = action.payload || action.error?.message || 'Failed to assign';
      })

      // ============================================================
      // DELETE PATIENT HANDLERS
      // ============================================================
      .addCase(deletePatient.pending, state => {
        state.isDeletingPatient = true
        state.deletePatientError = null
      })
      .addCase(deletePatient.fulfilled, (state, action) => {
        state.isDeletingPatient = false
        state.patients = state.patients.filter(patient => patient._id !== action.payload)
      })
      .addCase(deletePatient.rejected, (state, action) => {
        state.isDeletingPatient = false
        state.deletePatientError = action.error.message
      })

      // ============================================================
      // EDIT PATIENT HANDLERS
      // ============================================================
      .addCase(editPatient.fulfilled, (state, action) => {
        state.isEditingPatient = false
        state.isPatientEdited = true
        state.patients = state.patients.map(patient =>
          patient._id === action.payload._id ? action.payload : patient
        )
      })

      // ============================================================
      // GET SINGLE PATIENT HANDLERS
      // ============================================================
      .addCase(getPatient.pending, state => {
        state.isPatientLoading = true
        state.isPatientLoaded = false
        state.isPatientLoadingFailed = false
      })
      .addCase(getPatient.fulfilled, (state, action) => {
        state.isPatientLoading = false
        state.isPatientLoaded = true
        state.patient = action.payload
      })
      .addCase(getPatient.rejected, state => {
        state.isPatientLoading = false
        state.isPatientLoadingFailed = true
      })

      // ============================================================
      // GET ASSIGNEES HANDLERS
      // ============================================================
      .addCase(getAssignees.pending, state => {
        state.isAssigneesLoading = true
        state.isAssigneesLoaded = false
        state.isAssigneesLoadingFailed = false
      })
      .addCase(getAssignees.fulfilled, (state, action) => {
        state.isAssigneesLoading = false
        state.isAssigneesLoaded = true
        state.assignees = action.payload
      })
      .addCase(getAssignees.rejected, state => {
        state.isAssigneesLoading = false
        state.isAssigneesLoadingFailed = true
      })

      // ============================================================
      // GET ASSIGNED PATIENTS HANDLERS
      // ============================================================
      .addCase(getAssignedPatients.pending, state => {
        state.isAssignedPatientsLoading = true
        state.isAssignedPatientsLoaded = false
        state.isAssignedPatientsLoadingFailed = false
      })
      .addCase(getAssignedPatients.fulfilled, (state, action) => {
        state.isAssignedPatientsLoading = false
        state.isAssignedPatientsLoaded = true
        state.assignedPatients = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getAssignedPatients.rejected, (state, action) => {
        state.isAssignedPatientsLoading = false
        state.isAssignedPatientsLoadingFailed = true
        state.assignedPatients = state.assignedPatients || []
      })
  }
})

export default patients.reducer